import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { sameArray } from './same-array.esm.js';

var updateFieldsInLayout = function updateFieldsInLayout(layout, fields) {
  if (sameArray(layout.fields, fields)) {
    return layout;
  }
  return _objectSpread2(_objectSpread2({}, layout), {}, {
    fields: fields
  });
};

export { updateFieldsInLayout };
//# sourceMappingURL=update-fields-in-layout.esm.js.map
